export default __webpack_public_path__ + "static/media/guiaWindows2.265d006c.png";